import { action, observable, computed, makeObservable } from "mobx";
import { VehicleModel } from "../../ServicePlan/models/ServicePlanModels";

export default class CappedPricingCMSModel {
  @observable response: VehicleModel[] = [];
  @observable isContentExist: boolean = false;
  @observable isRequestError: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @computed get length() {
    return this.response ? this.response.length : 0;
  }

  @action reset = () => {
    this.response = null;
    this.isContentExist = false;
    this.isRequestError = false;
  };
}
